module.exports = __webpack_public_path__ + "img/PEUGEOT_2008.1070f74d.jpg";